import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import FeeModelsDisplay from 'src/mentor/components/ActiveFeeModels/components/FeeModelsDisplay'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams } from 'src/mentor/services'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getMinimalMentorData } from 'src/supportPortal/views/therapists/util'

export default function TherapistEngagementModels() {
  const { mentorSlug } = useParams()
  const [loading, setLoading] = useState(false)
  const [currentTherapist, setCurrentTherapist] = useState()
  const [loadingModels, setLoadingModels] = useState(false)
  const [entityFeeModels, setEntityFeeModels] = useState()
  const [inApplicableEntityFeeModels, setInApplicableEntityFeeModels] = useState()
  const [feeModels, setFeeModels] = useState()
  const [feeModelGroups, setFeeModelGroups] = useState()
  async function getSelectedTherapist() {
    const resp = await getMinimalMentorData(
      mentorSlug,
      true,
      `/api/secure/cc/support/therapists/by-slug?mentor-slug=${mentorSlug}`,
    )
    setCurrentTherapist(resp)
    return resp
  }

  async function getFeeModels(therapistData) {
    if (!therapistData?.id) return

    setLoadingModels(true)
    const resp = await getMPDataWithParams('/api/secure/cc/support/entity-fee-model/mentor/list', {
      mentorId: therapistData.id,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        const entityFeeModelsResp = data?.['entity-fee-model']
        const inApplicableEntityFeeModelsResp = data?.['inApplicable__entity-fee-model']
        setEntityFeeModels(entityFeeModelsResp)
        setInApplicableEntityFeeModels(inApplicableEntityFeeModelsResp)
        setFeeModels(data?.['fee-model'])
      }
    }
    setLoadingModels(false)
  }

  async function getFeeModelGroups() {
    const resp = await getMPDataWithParams(
      '/api/secure/cc/support/entity-fee-model/fee-model-group/list',
    )
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setFeeModelGroups(data?.['fee-model-group'])
      }
    }
  }

  async function setup() {
    setLoading(true)
    const therapistData = await getSelectedTherapist()
    if (therapistData?.id) {
      await getFeeModels(therapistData)
      await getFeeModelGroups()
    }
    setLoading(false)
  }

  useEffect(() => {
    setup()
  }, [mentorSlug])

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader
        heading={`${currentTherapist?.firstName || 'Therapist'} Engagement Models`}
      />
      {currentTherapist ? (
        <FeeModelsDisplay
          entityFeeModels={entityFeeModels}
          inApplicableEntityFeeModels={inApplicableEntityFeeModels}
          feeModels={feeModels}
          feeModelGroups={feeModelGroups}
          forMentor={true}
          loading={loadingModels}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100 w-100">
          <CircularProgress />
        </div>
      )}
    </div>
  )
}
